import { useCallback, useState } from 'react';

export type PudoListSortDirection = 'asc' | 'desc';

/** Oldest first = asc (default); newest first = desc. */
export const usePudoListSort = () => {
    const [sortDirection, setSortDirection] = useState<PudoListSortDirection>('asc');

    const toggleSortDirection = useCallback(() => {
        setSortDirection((current) => (current === 'desc' ? 'asc' : 'desc'));
    }, []);

    return {
        sortDirection,
        isNewestFirst: sortDirection === 'desc',
        toggleSortDirection
    };
};
